import { render, staticRenderFns } from "./putIntoDB.vue?vue&type=template&id=97a2cf3a&scoped=true&"
import script from "./putIntoDB.vue?vue&type=script&lang=js&"
export * from "./putIntoDB.vue?vue&type=script&lang=js&"
import style0 from "./putIntoDB.vue?vue&type=style&index=0&id=97a2cf3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a2cf3a",
  null
  
)

export default component.exports